import {
  Component,
  OnInit
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { RelatorioRecadastramentoService } from "../../../service/relatorio-recadastramento/relatorio.service";
import { RelatoriosSrhService } from "../../../service/relatorios-srh/relatorios-srh.service";
import { DynamicFormConfig } from "../../../commons/formulario-dinamico/types/dynamic-form-config";
import { Validators } from "@angular/forms";
import { HttpParams } from "@angular/common/http";
import { MatriculaUtil } from "../../../utils/matricula-util";
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-informacoes-funcionais-categorias',
  templateUrl: './informacoes-funcionais-categorias.component.html',
  styleUrls: ['./informacoes-funcionais-categorias.component.sass']
})
export class InformacoesFuncionaisCategoriasComponent implements OnInit {
  matricula: number;
  servidor: any = JSON.parse(sessionStorage.getItem("SessionDataUserAuth"));
  private tipoRelatorio: number;
  private _urlTipoRelatorio = "informacoes-funcionais";
  config: DynamicFormConfig[] = [];
  nameFile: string;

  constructor(private toastrService: ToastrService,
              private relatorioService: RelatorioRecadastramentoService,
              private relatoriosSrhService: RelatoriosSrhService,
              private toasterService: ToastrService) {
    this.relatoriosSrhService.tipoRelatorio$.subscribe(resp => {
      this.tipoRelatorio = resp;
      this.routerMap();
    });

  }

  ngOnInit(): void {

  }

  routerMap(): void {
    this._urlTipoRelatorio = this._urlTipoRelatorio.split("/")[0];
    switch (this.tipoRelatorio) {
      case 1:
        this.nameFile = 'relatorio-fuc-dependentes'
        this._urlTipoRelatorio = this._urlTipoRelatorio+ "/dependentes";
        this.buildFormulario1();
        break;

      case 2:
        this.nameFile = 'relatorio-fuc-certidao-tempo-servico'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/certidao-tempo-servico";
        this.buildFormulario1();
        break;

      case 3:
        this.nameFile = 'relatorio-fuc-certidao-lotacoes'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/certidao-lotacoes";
        this.buildFormulario1();
        break;

      case 4:
        this.nameFile = 'relatorio-fuc-certidao-tempo-servico'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/certidao-tempo-servico";
        this.buildFormulario1();
        break;

      case 5:
        this.nameFile = 'relatorio-fuc-progressao-funcional'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/progressao-funcional";
        this.buildFormulario1();
        break;

      case 6:
        this.nameFile = 'relatorio-fuc-certidao-ats'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/certidao-ats";
        this.buildFormulario1();
        break;

      case 7:
        this.nameFile = 'relatorio-fuc-consulta-previdenciaria'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/consulta-previdenciaria";
        this.buildFormulario2();
        break;

      case 8:
        this.nameFile = 'relatorio-fuc-adiantamento-13'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/adiantamento-13";
        this.buildFormulario1();
        break;

      case 9:
        this.nameFile = 'relatorio-fuc-qualificacao-funcional'
        this._urlTipoRelatorio = this._urlTipoRelatorio+"/qualificacao-funcional";
        this.buildFormulario3();
        break;

      default:
        break;

    }
  }

  private buildFormulario1(): void {
    this.config = [
      {
        type: 'autoCompleteServidor',
        class: 'col-md-12',
        label: 'Matrícula com dígito',
        initialValue: `${this.servidor.matricula} - ${this.servidor.nome}`,
        disabled: (this.servidor.perfil == 'M') || (this.servidor.perfil == 'S') ? false : true,
        name: ['servidor'],
        placeholder: 'Digite o Nome do Servidor',
        validation: [Validators.required],
      }
    ]
  }

  private buildFormulario2(): void {
    this.config = [
      {
        type: 'autoCompleteServidor',
        class: 'col-md-12',
        label: 'Matrícula com dígito',
        initialValue: `${this.servidor.matricula} - ${this.servidor.nome}`,
        disabled: (this.servidor.perfil == 'M') || (this.servidor.perfil == 'S') ? false : true,
        name: ['servidor'],
        placeholder: 'Digite o Nome do Servidor',
        validation: [Validators.required],
      },
      {
        type: 'betweenDate',
        class: '',
        label: 'Período do Relatório*',
        disabled: false,
        name: ['dataInicio', 'dataFim'],
        placeholder: 'Selecione uma data',
        validation: [
          Validators.required
        ],
      }
    ];
  }

  private buildFormulario3(): void {
    this.config = [
      {
        type: 'autoCompleteServidor',
        class: 'col-md-12',
        label: 'Matrícula com dígito',
        initialValue: `${this.servidor.matricula} - ${this.servidor.nome}`,
        disabled: (this.servidor.perfil == 'M') || (this.servidor.perfil == 'S') ? false : true,
        name: ['servidor'],
        placeholder: 'Digite o Nome do Servidor',
        validation: [Validators.required],
      },
      {
        type: 'date',
        class: '',
        label: 'Data*',
        disabled: false,
        name: ['data'],
        placeholder: 'Selecione uma data',
        validation: [
          Validators.required
        ],
      }
    ];
  }

  public buscarRelatorio(form) {
    let params = new HttpParams()
      .set('matricula', MatriculaUtil.extrairMatricula(form));

    this.tipoRelatorio == 7 ?
      (params = params.append("dataFim", new Date(form.value.dataFim).toLocaleString().slice(0, 10)),
        params = params.append("dataInicio", new Date(form.value.dataInicio).toLocaleString().slice(0, 10))) : false;

    this.tipoRelatorio == 9 ? params = params.append('data', new Date(form.value.data).toLocaleString().slice(0, 10)) : false;

    this.relatoriosSrhService.getRelatorios(params, this._urlTipoRelatorio).subscribe( (resp: Blob) => {
      let blobRg: Blob;
      const fileType = resp.type || 'application/octet-stream';

      let fileName = this.nameFile;
      const fileExtension = this.getFileExtensionFromMimeType(fileType);

      if (fileExtension) {
        fileName += '.' + fileExtension;
      }

      blobRg = new Blob([resp], { type: fileType });
      this.downloadFile(blobRg, fileName);

    })
  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
    const extensionMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'image/png': 'png'
      // Adicione outras extensões e tipos MIME conforme necessário
    };

    return extensionMap[mimeType] || null;
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso');
  }


}
